import type { DialogProperties } from '@/components/ui/dialog';
import { Dialog } from '@/components/ui/dialog';

type DrawerProperties = Omit<DialogProperties, 'placement'> & {
  side?: 'left' | 'right';
};

export const Drawer = ({ side = 'left', ...properties }: DrawerProperties) => <Dialog placement={side} {...properties} />;
